import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["oppositeTeam"],
  _excluded2 = ["className", "compact", "court", "detailsUrl", "event", "matchDateTime", "matchNumber", "matchTime", "round", "teams", "tournament"];
import clsx from "clsx";
import React, { useEffect, useRef } from "react";
import { mergeRefs } from "../../utils";
var styles = {
  "match__card": "pbui-bIm7j",
  "match__card--compact": "pbui-djpoI",
  "card__number": "pbui-f7yBV",
  "card__body": "pbui-e5lkC",
  "body__header": "pbui--SPCZ",
  "body__details": "pbui-J8Fcw",
  "details__list": "pbui-NTViz",
  "details__link": "pbui-8b1Y9",
  "team__player": "pbui-7iraL",
  "body__footer": "pbui-fwnq2",
  "card__title": "pbui-RM3o0",
  "card__details_url": "pbui-VLgZt",
  "match__card_team_container": "pbui-76jSF",
  "match__card_team_avatar": "pbui-TeqMr",
  "match__card_player_name": "pbui-Lbr8M",
  "match__card_player_name_semibold": "pbui-bAFhK",
  "match__card_player_name_winning": "pbui-4xOnW",
  "success": "pbui-dFPOz",
  "match__card_player_name_results": "pbui-isS5h",
  "match__card_player_name_results_iswinner": "pbui-gBUo3",
  "match__card_player_name_results_isnotwinner": "pbui-aYxAu",
  "match__card_player_auto": "pbui-Pv-OI"
};
import { PlayerAvatar } from "./PlayerAvatar";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EMPTY_STRING_PLACE = "_";
export var MatchCardTeam = function MatchCardTeam(_ref) {
  var _team$scores;
  var oppositeTeam = _ref.oppositeTeam,
    team = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.team__player,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.match__card_team_container,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.match__card_team_avatar,
        children: team.players.map(function (player) {
          return /*#__PURE__*/_jsx(PlayerAvatar, {
            size: "xs"
          }, player.id);
        })
      }), /*#__PURE__*/_jsx("div", {
        children: team.players.map(function (player) {
          return /*#__PURE__*/_jsxs("div", {
            className: styles.match__card_player_name,
            children: [player.firstName.length > 0 ? "".concat(player.firstName.charAt(0).toUpperCase()).concat(player.lastName ? ", " : "") : "".concat(EMPTY_STRING_PLACE, ", "), player.lastName.length > 0 ? /*#__PURE__*/_jsx("span", {
              className: styles.match__card_player_name_semibold,
              children: "".concat(player.lastName.charAt(0).toUpperCase()).concat(player.lastName.substring(1))
            }) : EMPTY_STRING_PLACE]
          }, player.id);
        })
      }), /*#__PURE__*/_jsx("span", {
        className: "".concat(styles.match__card_player_name_winning, " ").concat(team.winningPercentage && team.winningPercentage > 50 ? styles.match__card_player_name_winning : ""),
        children: "".concat(team.winningPercentage, "%")
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.match__card_player_auto,
      children: (_team$scores = team.scores) == null ? void 0 : _team$scores.map(function (score, index) {
        return /*#__PURE__*/_jsx("div", {
          className: "".concat(styles.match__card_player_name_results, " ").concat(score.winner ? styles.match__card_player_name_results_iswinner : styles.match__card_player_name_results_isnotwinner),
          children: score.value === 0 && oppositeTeam.scores && oppositeTeam.scores[index].value === 0 ? '-' : score.value
        }, score.value);
      })
    })]
  });
};
var MatchCard = /*#__PURE__*/React.forwardRef(function MatchCard(props, propRef) {
  var className = props.className,
    compact = props.compact,
    court = props.court,
    detailsUrl = props.detailsUrl,
    event = props.event,
    matchDateTime = props.matchDateTime,
    matchNumber = props.matchNumber,
    matchTime = props.matchTime,
    round = props.round,
    teams = props.teams,
    tournament = props.tournament,
    rest = _objectWithoutProperties(props, _excluded2);

  /* const [width, setWidth] = useState<number>(); */
  var cardRef = useRef(null);
  var ref = mergeRefs([propRef, cardRef]);
  var renderCourtMatchTime;
  if (matchTime) {
    if (typeof matchTime === "string") {
      renderCourtMatchTime = matchTime;
    } else {
      renderCourtMatchTime = matchTime.toISOString();
    }
  }
  var matchCardClasses = clsx(styles.match__card, className, compact && styles["match__card--compact"]);
  useEffect(function () {
    if (cardRef.current) {
      // const rect = cardRef.current.getBoundingClientRect();
      // setWidth(rect.width);
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", _extends({
    className: matchCardClasses
  }, rest, {
    ref: ref,
    children: [matchNumber && /*#__PURE__*/_jsx("div", {
      className: styles.card__number,
      children: matchNumber
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.card__body,
      children: [(tournament || event) && /*#__PURE__*/_jsxs("div", {
        className: styles.body__header,
        children: [tournament && /*#__PURE__*/_jsx("div", {
          className: styles.card__title,
          style: {
            width: "100%"
          },
          children: tournament
        }), event && /*#__PURE__*/_jsx("div", {
          className: styles.card__title,
          style: {
            width: 360
          },
          children: event
        })]
      }), (court || round || renderCourtMatchTime) && /*#__PURE__*/_jsxs("div", {
        className: styles.body__details,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.details__list,
          children: [/*#__PURE__*/_jsx("div", {
            children: "Court ".concat(court)
          }), /*#__PURE__*/_jsx("div", {
            children: "Round ".concat(round)
          }), /*#__PURE__*/_jsx("div", {
            children: renderCourtMatchTime
          })]
        }), detailsUrl && /*#__PURE__*/_jsx("div", {
          className: styles.card__details_url,
          children: detailsUrl
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.card__team,
        children: [teams && teams[0] && /*#__PURE__*/_jsx(MatchCardTeam, _extends({}, teams[0], {
          oppositeTeam: teams[1]
        })), teams && teams[1] && /*#__PURE__*/_jsx(MatchCardTeam, _extends({}, teams[1], {
          oppositeTeam: teams[0]
        }))]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.body__footer,
        children: matchDateTime || ""
      })]
    })]
  }));
});
export default MatchCard;